import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/i18n';
import EfImg from '@elem/ui/ef-img';
import EcoSpace from 'eco-design/base/eco-space';
import EcoSpaceSmall from 'eco-design/base/eco-space-small';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import { useCallback, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import Modal from './Modal';
import styles from './index.module.scss';
import type { prodcutItemType } from './useProductList';
import { useProductList } from './useProductList';

import gtm from '@/utils/gtm';

const RightArrow = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="31" height="31" viewBox="0 0 31 31" fill="none">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15.5 4.25C21.7132 4.25 26.75 9.2868 26.75 15.5C26.75 21.7132 21.7132 26.75 15.5 26.75C9.2868 26.75 4.25 21.7132 4.25 15.5C4.25 9.2868 9.2868 4.25 15.5 4.25ZM12.3371 11.1629C11.971 10.7968 11.971 10.2032 12.3371 9.83709C12.7032 9.47097 13.2968 9.47097 13.6629 9.83709L18.6629 14.8371C19.029 15.2032 19.029 15.7968 18.6629 16.1629L13.6629 21.1629C13.2968 21.529 12.7032 21.529 12.3371 21.1629C11.971 20.7968 11.971 20.2032 12.3371 19.8371L16.6742 15.5L12.3371 11.1629Z"
                fill="url(#paint0_linear_956_13681)"
            />
            <defs>
                <linearGradient id="paint0_linear_956_13681" x1="1.43112" y1="27.5741" x2="1.54714" y2="6.92154" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#FAA10E" />
                    <stop offset="1" stopColor="#E35D14" />
                </linearGradient>
            </defs>
        </svg>
    );
};

const GoodsA = () => {
    const { locale } = getLocal();
    const { t } = useLang('theProduct.GoodsA');
    const { productList } = useProductList(locale);

    const [gap, setGap] = useState(16);
    const [currentLink, setCurrentLink] = useState('');
    const [isChecked, setIsChecked] = useState(false);
    const [isClient, setIsClient] = useState(false);
    const [isShowModal, setIsShowModal] = useState(false);

    const handleBuyNow = useCallback(
        (link: string) => {
            if (locale === 'de') {
                setCurrentLink(link);
                setIsShowModal(true);
                // dialogRef?.current?.showModal();
                return;
            }
            if (link) {
                try {
                    gtm.push({
                        event: 'uaEvent',
                        event_name: 'checkout',
                        button_name: `${t('buy_now')}`,
                    });
                } catch (e) {
                    console.log(e);
                }
                window.open(link, '_blank');
            }
        },
        [locale, t],
    );

    const handleViewMore = useCallback((link?: string) => {
        if (link) {
            try {
                gtm.push({
                    event: 'uaEvent',
                    event_name: 'buy',
                    product_name: 'Solar System',
                    position: 'Choose Your Balcony Solar System_Custom Now',
                });
            } catch (e) {
                console.log(e);
            }
            window.open(link, '_blank');
        }
    }, []);

    const handleGtm = useCallback(
        (btnName: string) => {
            try {
                gtm.push({
                    event: 'uaEvent',
                    event_name: 'product_detail_page',
                    list_name: t('title'),
                    button_name: btnName,
                });
            } catch (e) {
                console.log(e);
            }
        },
        [t],
    );

    useEffect(() => {
        if (typeof window !== 'undefined') {
            if (window.innerWidth < 1024) {
                setGap(16);
            } else {
                setGap(24);
            }
        }

        if (typeof window !== 'undefined') {
            setIsClient(true);
        }
    }, []);

    return (
        <div className={styles.comp}>
            <EcoSpace />
            <EcoSectionCommon title={t('title')} />
            <EcoSpaceSmall />
            <Swiper
                className="products"
                modules={[Navigation]}
                spaceBetween={gap}
                slidesPerView={'auto'}
                initialSlide={0}
                navigation
                onSlidePrevTransitionStart={() => {
                    handleGtm('Left switch');
                }}
                onSlideNextTransitionStart={() => {
                    handleGtm('Right switch');
                }}
            >
                {productList.length > 1 &&
                    productList?.map((item: prodcutItemType, k: number) => {
                        if (!item) {
                            return null;
                        }
                        if (!item?.tag) {
                            return (
                                <SwiperSlide className={`product item-${k + 1}`} key={k}>
                                    <div className="item">
                                        <EfImg className="item-img" pc={item.variantImg} h5={item?.variantImg} />
                                        <div className="text-container">
                                            <div className="title">{item.title}</div>
                                            <div className="desc">{item.desc}</div>
                                        </div>
                                        <div className="progress-bar">
                                            <div className="current">{item.saving}</div>
                                        </div>
                                        <div className="value-show">
                                            <div className="tab">
                                                <div className="value-line1">{item.power}</div>
                                                <div className="value-line2">{item.powerSuffix}</div>
                                            </div>
                                            <div className="vertical-line"></div>
                                            <div className="tab">
                                                <div className="value-line1">{item.efficiency}</div>
                                                <div className="value-line2">{item.efficiencySuffix}</div>
                                            </div>
                                        </div>
                                        <div className="price-container">
                                            <div className="price1">{item.price}</div>
                                            <div className="price2">{item.compareAtPrice}</div>
                                        </div>
                                        <div className="btn-buy" onClick={() => handleBuyNow(item?.link_buy)}>
                                            {t('buy_now')}
                                        </div>
                                    </div>
                                </SwiperSlide>
                            );
                        }
                        return (
                            <SwiperSlide className={`product item-${k + 1}`} key={k}>
                                <div className="item last-item">
                                    <div className="last-item-desc">{t('card_desc')}</div>
                                    <div
                                        className="last-item-btn"
                                        onClick={() => {
                                            handleViewMore(item?.tag);
                                            if (isChecked) {
                                                handleViewMore(currentLink);
                                            }
                                            setCurrentLink('');
                                        }}
                                    >
                                        {t('btn_text')}
                                        <RightArrow />
                                    </div>
                                </div>
                            </SwiperSlide>
                        );
                    })}
            </Swiper>

            {isClient &&
                createPortal(
                    <Modal
                        open={isShowModal}
                        onClose={() => {
                            setIsShowModal(false);
                        }}
                        callback={() => {
                            handleViewMore(currentLink);
                        }}
                        handleRead={setIsChecked}
                    ></Modal>,
                    document.body,
                )}
        </div>
    );
};

export default GoodsA;
